import { render, staticRenderFns } from "./SpecialitiesSelect.vue?vue&type=template&id=34f67c0c&"
import script from "./SpecialitiesSelect.vue?vue&type=script&lang=js&"
export * from "./SpecialitiesSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports